import React, { useState, useEffect } from "react";
export default function HomeComponent() {
    const [loading] = useState(false);

    useEffect(() => {
    }, []);

    return (
        <>
            <div className="content">
                <div className="row no-gutters justify-content-center">
                    <div className="hero-static col-sm-10 col-md-8 col-xl-6 d-flex align-items-center p-2 px-sm-0">
                        <div className="block block-rounded block-transparent block-fx-pop w-100 mb-0 overflow-hidden bg-image">

                        <div className="content privacy-policy">
                            <h1>Políticas de Privacidade</h1>
                            <p>
                                Bem-vindo ao Habitaki! Sua privacidade é importante para nós. Esta política descreve como coletamos, usamos e protegemos suas informações pessoais.
                            </p>
                            <h2>Coleta de Informações</h2>
                            <p>
                                Coletamos informações fornecidas por você, como nome, e-mail e dados de contato, bem como informações sobre o uso do aplicativo, incluindo preferências e interações.
                            </p>
                            <h2>Uso das Informações</h2>
                            <p>
                                Utilizamos suas informações para melhorar sua experiência, personalizar anúncios, fornecer suporte e enviar comunicações relevantes.
                            </p>
                            <h2>Compartilhamento de Informações</h2>
                            <p>
                                Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir a lei ou fornecer os serviços do aplicativo. Além disso, não fornecemos os dados de contato do cliente para os corretores e nem imobiliárias.
                            </p>
                            <h2>Segurança</h2>
                            <p>
                                Implementamos medidas de segurança para proteger suas informações contra acesso não autorizado, alteração ou divulgação.
                            </p>
                            <h2>Alterações na Política</h2>
                            <p>
                                Podemos atualizar esta política periodicamente. Recomendamos revisar esta página regularmente para se manter informado.
                            </p>
                            <h2>Contato</h2>
                            <p>
                                Se tiver dúvidas sobre esta política, entre em contato conosco pelo e-mail suporte@habitaki.com.
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
